export default __webpack_public_path__ + "static/media/spark_90.aef5fd7e.png";